import React, { Component } from 'react';
import { Input } from 'reactstrap';
import { connect } from 'react-redux';
import { Row, Col } from 'react-bootstrap';
import { showToast } from '../../../actions/Actions.js';
import Select from '../../components/Select.js';
import Spinner from '../../components/Spinner.js';
import '../../../css/CommonTheme.css';
import '../../../css/AccountSettings.css';
import { updateQbClassSuccess, selectQbClass } from '../../../actions/QbClassActions.js';
import { updateExistingQbClass } from '../../../requests/QbClassRequests.js';

const qbClassFields = ['id', 'name', 'active', 'account_id'];

class EditQbClassForm extends Component {
    constructor(props) {
        super(props);
        this.state = this.defaultState();
    }

    defaultState = () => {
        const { qbClass, accountId } = this.props;
        return {
            nameInvalidMsg: '',
            name: qbClass ? qbClass.name : '',
            markAsInactive: qbClass ? qbClass.hidden === 'Yes' : false,
            account_id: accountId,
            spinner_loader: false,
        };
    };

    componentWillReceiveProps(nextProps) {
        if (nextProps.qbClass && nextProps.qbClass !== this.props.qbClass) {
            this.setState({
                name: nextProps.qbClass.name || '',
                markAsInactive: nextProps.qbClass.hidden === 'Yes',
            });
        }
    }

    constructQbClass = () => {
        const data = {};
        qbClassFields.forEach(field => {
            if (field in this.state) {
                data[field] = this.state[field];
            }
        });
        // Convert active back to hidden for API
        data.hidden = data.active === 'Yes' ? 'No' : 'Yes';
        delete data.active;
        return data;
    };

    checkRequiredFields = () => {
        const { name } = this.state;
        if (name === '') {
            this.props.showToast('Please fill out the class name', 'warning');
            return false;
        }
        return true;
    };

    updateQbClass = async event => {
        event.preventDefault();
        if (this.state.nameInvalidMsg !== '') {
            this.props.showToast('Please fix the form errors before submitting', 'warning');
            return;
        }

        if (!this.checkRequiredFields()) {
            return;
        }

        this.setState({ spinner_loader: true });

        try {
            const qbClass = this.constructQbClass();
            const qbClassId = this.props.qbClass.id;

            // Format for Rails strong params
            const apiData = {
                id: qbClassId, // For the URL path
                'QuickbooksClass[id]': qbClassId,
                'QuickbooksClass[name]': qbClass.name,
                'QuickbooksClass[hidden]': this.state.markAsInactive,
                'QuickbooksClass[account_id]': qbClass.account_id,
            };

            const result = await updateExistingQbClass(apiData);
            this.props.updateQbClassSuccess(result);
            this.props.showToast('QB Class updated successfully', 'success');

            setTimeout(() => {
                this.setState({ spinner_loader: false });
                this.props.history.push('/resource_settings/classes');
            }, 1000);
        } catch (error) {
            console.error('Error updating QB Class:', error);
            this.props.showToast('Failed to update QB Class. Please try again.', 'error');
            this.setState({ spinner_loader: false });
        }
    };

    handleNameChanged = event => {
        const name = event.target.value;
        this.setState({ name });
        if (name === '') {
            this.setState({ nameInvalidMsg: 'Class name is required' });
        } else {
            this.setState({ nameInvalidMsg: '' });
        }
    };

    handleInactiveCheckboxChanged = event => {
        this.setState({ markAsInactive: event.target.checked });
    };

    render() {
        const { qbClass } = this.props;
        const { name, markAsInactive, nameInvalidMsg, spinner_loader } = this.state;

        if (!qbClass) {
            return (
                <div className="applicationWrapper">
                    <div className="applicationBody">
                        <div className="bodyHeader">
                            <h2>QB Class Not Found</h2>
                        </div>
                        <p>The QB Class you're trying to edit was not found.</p>
                        <button
                            className="primaryButton"
                            onClick={() => this.props.history.push('/resource_settings/classes')}
                        >
                            Back to Classes
                        </button>
                    </div>
                </div>
            );
        }

        return (
            <div className="applicationWrapper">
                <div className="applicationBody">
                    <div className="bodyHeader">
                        <h2>Edit QB Class: {qbClass.name}</h2>
                    </div>
                    <div className="accountSettingsContainer">
                        <form onSubmit={this.updateQbClass}>
                            <Row>
                                <Col md={6}>
                                    <div className="stackedLabelAndInput fieldGroup">
                                        <label className="inputLabel">Class Name *</label>
                                        <Input
                                            type="text"
                                            value={name}
                                            onChange={this.handleNameChanged}
                                            className={nameInvalidMsg ? 'invalidInput' : ''}
                                            placeholder="Enter class name"
                                        />
                                        {nameInvalidMsg && (
                                            <div className="invalidInputMsg">{nameInvalidMsg}</div>
                                        )}
                                    </div>
                                </Col>
                            </Row>
                            <Row>
                                <Col md={6}>
                                    <div className="stackedLabelAndInput fieldGroup">
                                        <label
                                            className="inputLabel"
                                            style={{
                                                display: 'flex',
                                                alignItems: 'center',
                                                whiteSpace: 'nowrap',
                                            }}
                                        >
                                            <input
                                                type="checkbox"
                                                checked={markAsInactive}
                                                onChange={this.handleInactiveCheckboxChanged}
                                                style={{ marginRight: '8px' }}
                                            />
                                            Mark class as inactive
                                        </label>
                                    </div>
                                </Col>
                            </Row>
                            <Row>
                                <Col md={12}>
                                    <div className="fieldGroup">
                                        <button
                                            type="submit"
                                            className="primaryButton"
                                            disabled={spinner_loader}
                                        >
                                            {spinner_loader ? <Spinner /> : 'Update QB Class'}
                                        </button>
                                        <button
                                            type="button"
                                            className="secondaryButton"
                                            onClick={() =>
                                                this.props.history.push(
                                                    '/resource_settings/classes'
                                                )
                                            }
                                            style={{ marginLeft: '10px' }}
                                        >
                                            Cancel
                                        </button>
                                    </div>
                                </Col>
                            </Row>
                        </form>
                    </div>
                </div>
            </div>
        );
    }
}

function mapStateToProps(state) {
    return {
        accountId: state.accountStore.id,
        qbClass: state.businessResourcesStore.selectedQbClass,
    };
}

const mapDispatchToProps = {
    showToast,
    updateQbClassSuccess,
    selectQbClass,
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(EditQbClassForm);
